import ModelUtil from '@leverege/model-util';
import { Config } from '@leverege/plugin';
const TYPE = 'molten.dataViewer.responsive.ResponsiveModel';
const ResponsiveModel = {
  TYPE,
  create,
  ...ModelUtil.createAllArray('dataViewers', 'dataViewer'),
  ...ModelUtil.createAllArray('breakpoints', 'breakpoint'),
  setDataViewerSettings,
  getDataViewerForSize
};
function create(opts, props) {
  const {
    dataViewers,
    breakpoints = null
  } = opts || {};
  return {
    type: TYPE,
    dataViewers: dataViewers || [],
    breakpoints: breakpoints || []
  };
}

/**
 * 
 * @param {ResponsiveModel} model The repsonsive model to get data from
 * @param {number} size the width of the parent space.
 * @returns array [ dataViewer, index ]
 */
function getDataViewerForSize(model, size) {
  const dvs = model.dataViewers || [];
  const bps = model.breakpoints || [];
  let current = dvs[0] || null;
  let index = 0;
  for (let n = 0; n < dvs.length; n++) {
    if (n !== dvs.length - 1) {
      let bp = bps[n];
      if (typeof bp === 'string') {
        bp = Config.get('ResponsiveDataViewer', bps[n], 640);
      }
      if (bp == null) {
        bp = Config.get('ResponsiveDataViewer', 'minWidth', 640);
      }
      if (typeof bp === 'number' && size < bp) {
        return [current, n];
      }
    }
    if (dvs[n]) {
      current = dvs[n];
      index = n;
    }
  }
  return [current, index];
}
function setDataViewerSettings(model, index, settings) {
  const dv = ResponsiveModel.getDataViewer(model, index);
  if (dv == null || dv.settings === settings) {
    return model;
  }
  return ResponsiveModel.setDataViewer(model, index, {
    ...dv,
    settings
  });
}
export default ResponsiveModel;